import { ErrorBoundary } from './components/ErrorBoundary';
import { Beregner } from './pages/Beregner';

export default function App() {
  return (
    <ErrorBoundary>
      <Beregner />
    </ErrorBoundary>
  );
}
